export const TRIGGER_ACTIONS = {
	ON_CLICK: 'OnClick',
	ON_CLUSTERED_PIVOT_FINISHED: 'OnClusteredPivotFinished'
};